import { useMemo } from "react";
import { Box, Card, CardContent, Grid, Avatar, Typography, Button, Chip } from "@mui/material";
import DataTableWithSearch from "../../../../components/dataTableWithSearch/DataTableWithSearch";
import { APP_ROUTES } from "../../../../config/appRoutes";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";

const vitals = [
    { label: "Blood Pressure", value: "120/89", unit: "mm/hg", status: "In the norm", color: "success" },
    { label: "Heart Rate", value: "120", unit: "BPM", status: "Above the norm", color: "error" },
    { label: "Glucose", value: "97", unit: "mg/dl", status: "In the norm", color: "success" },
    { label: "Cholesterol", value: "85", unit: "mg/dl", status: "In the norm", color: "success" },
];

const historyData = [
    {
        date: "20 Jan, 2023",
        diagnosis: "Malaria",
        severity: "High",
        visits: 2,
        status: "Under Treatment",
    },
    {
        date: "12 Jan, 2022",
        diagnosis: "Viral Fever",
        severity: "Low",
        visits: 1,
        status: "Cured",
    },
    {
        date: "20 Jan, 2021",
        diagnosis: "Covid 19",
        severity: "High",
        visits: 6,
        status: "Cured",
    },
];

const PatientHistory = () => {
    const navigate = useNavigate();

    const columns = useMemo(() => [
        { header: "SNO", accessorKey: "sno", enableGlobalFilter: true },
        { header: "Appointment Date", accessorKey: "date" },
        { header: "Appointment Date", accessorKey: "diagnosis" },
        { header: "Appointment Date", accessorKey: "severity" },
        { header: "Appointment Date", accessorKey: "status" },
    ], []);

    return (
        <>
            <Grid container spacing={1}>
                <Grid item size={{ xs: 12, md: 4 }} sx={{ mb: 2 }}>
                    <Button size="small" variant="outlined" sx={{
                        mt: 1, borderRadius: 12, border: "1px solid var(--btn-1)", color: "var(--btn-1)", p: 0.5, "&:hover": {
                            background: "linear-gradient(135deg, #e87103, #f5b942)",
                            transform: "scale(1.1)",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                            color: "var(--background)"
                        },
                    }} onClick={() => navigate(APP_ROUTES.APPOINTMENTS.LIST)}>
                        <ArrowBackIcon /> &nbsp; Back
                    </Button>
                </Grid>
            </Grid>

            <Box sx={{ background: "var(--border)" }} p={2}>
                <Card>
                    <CardContent sx={{ p: 2 }}>
                        <Grid container spacing={1} sx={{ p: 3 }}>
                            <Grid item size={{ xs: 12, md: 4 }} sx={{ borderRight: "1px solid var(--btn-1)" }}>
                                <Avatar
                                    src="https://i.pravatar.cc/150"
                                    sx={{ width: 100, height: 100 }}
                                />
                                <Typography variant="h6">Mrs. Maria Waston</Typography>
                                <Typography color="text.secondary">
                                    mariawaston2022@gmail.com
                                </Typography>

                                <Button size="small" variant="outlined" sx={{
                                    mt: 1, borderRadius: 12, border: "1px solid var(--btn-1)", color: "var(--btn-1)", p: 1, "&:hover": {
                                        background: "linear-gradient(135deg, #e87103, #f5b942)",
                                        transform: "scale(1.1)",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                        color: "var(--background)"
                                    },
                                }}>
                                    Edit Profile
                                </Button>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 8 }} sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    {[
                                        ["Sex", "Female"],
                                        ["Age", "28"],
                                        ["Blood", "A+"],
                                        ["Status", "Active"],
                                        ["Department", "Cardiology"],
                                        ["Registered Date", "20 Jan, 2023"],
                                        ["Appointment", "35"],
                                        ["Bed Number", "#0365"],
                                    ].map(([label, value]) => (
                                        <Grid item size={{ xs: 12, md: 4 }} key={label}>
                                            <Typography variant="caption" color="text.secondary">
                                                {label}
                                            </Typography>
                                            <Typography fontWeight={600}>{value}</Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                {/* Patient Current Vitals */}
                <Typography variant="h6" mb={0} p={2} color="#fff">
                    Patient Current Vitals
                </Typography>

                <Grid container spacing={1}>
                    {vitals.map((item) => (
                        <Grid item size={{ xs: 12, md: 3 }} md={3} key={item.label}>
                            <Card sx={{ borderRadius: 3 }}>
                                <CardContent>
                                    <Typography variant="caption" color="text.secondary">
                                        {item.label}
                                    </Typography>
                                    <Typography variant="h5" fontWeight={700}>
                                        {item.value}{" "}
                                        <Typography component="span" variant="body2">
                                            {item.unit}
                                        </Typography>
                                    </Typography>
                                    <Chip
                                        size="small"
                                        label={item.status}
                                        color={item.color}
                                        sx={{ mt: 1 }}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>


                <Box mt={2}>
                    <Card>
                        <CardContent>
                            <DataTableWithSearch
                                columns={columns}
                                data={historyData}
                                status={false}
                            />
                        </CardContent>
                    </Card>
                </Box>
            </Box>
        </>
    )
};
export default PatientHistory;